<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div
    class="columns columns--full is-vcentered onboarding-create-site__step10"
  >
    <div class="column has-text-centered onboarding-create-site__description">
      <div class="onboarding-create-site__description--width-80">
        <p></p>
        <h1 class="onboarding-create-site__title has-text-weight-bold">
          🎉 <br />
          Seu site já está no ar!
        </h1>
        <p class="onboarding-create-site__step10--url-wedding">
          {{ getUrlWedsite() }}
        </p>
        <p class="onboarding-create-site__step10--subtitle">
          Agora vocês podem personalizar deixando-o do seu jeito e compartilhar
          o link com seus convidados.
        </p>
        <p class="onboarding-create-site__step10--subtitle">
          <span>
            Ah! E não esqueça estamos aqui para ajudar sempre que você precisar
            😉</span
          >
        </p>
        <div>
          <button
            class="button is-big is-primary"
            @click="OnboardingFinish()"
            id="onboardingFinish"
          >
            Concluir
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const API_LEGACY_URL = process.env.VUE_APP_API_LEGACY_URL

export default {
  data() {
    return {
      allAnswerOnboarding: {},
      nameUrlWed: '',
    }
  },

  computed: {
    answerUser: {
      get() {
        return this.$store.state.onboardingCreateSite.answersOfStep
      },
      set(payload) {
        this.$store.dispatch('setAnswer', payload)
      },
    },
  },

  methods: {
    getAnswersOnboarding() {
      return JSON.parse(
        localStorage.getItem(`onboarding_wed${this.answerUser.wed_id}`)
      )
    },

    getUrlWedsite() {
      const result = API_LEGACY_URL.split('//')
      const answersOnboarding = this.getAnswersOnboarding()

      return result[1] + '/' + answersOnboarding.website_url
    },

    async OnboardingFinish() {
      const logonToken = this.$store.state.app.logonToken
      const answersOnboarding = this.getAnswersOnboarding()

      // User jump all steps
      if (answersOnboarding) {
        // eslint-disable-next-line prettier/prettier
        window.location.href = `${API_LEGACY_URL}/${logonToken.token_payload.wed_id}`
      } else {
        // eslint-disable-next-line prettier/prettier
        window.location.href = `${API_LEGACY_URL}/${logonToken.token_payload.wed_id}?skip_onboarding=1`
      }
    },
  },
}
</script>

<style lang="scss">
.onboarding-create-site {
  &__step10 {
    @media (min-width: $desktop) {
      width: 70%;
      max-width: 1095px;
      margin: 0 auto;
    }

    p {
      font-size: 18px;
      margin-bottom: 10px;

      @media (min-width: $desktop) {
        font-size: 24px;
        margin-bottom: 15px;
      }
    }

    &--url-wedding {
      color: $primary;
    }

    &--subtitle {
      color: $gray-7;

      span {
        font-size: 16px;
      }
    }

    button {
      margin-top: 20px;
      min-width: 150px;
    }
  }
}
</style>
